import React, { useEffect } from 'react';
import { Deck } from './components/Deck';
const DECK_TITLE = 'Isochron Seed Deck';
export function App() {
  useEffect(() => {
    document.title = DECK_TITLE;
    const setMeta = (attribute: 'property' | 'name', key: string, content: string) => {
      let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attribute, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('property', 'og:title', DECK_TITLE);
    setMeta('name', 'twitter:title', DECK_TITLE);
  }, []);
  return <Deck data-id="element-0" data-mp="31cjjro54x0vk" />;
}